import moment from 'moment';
import { MonthlyInOut } from '../services/cashflowService';

export const MAX_BAR_HEIGHT = 200;

export const numberToHumanReadable = (amount: number): string => Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatLastFourMonths = (monthlyInOutData: MonthlyInOut[]): MonthlyInOut[] => {
  const calculateBarHeights = (data: MonthlyInOut[]): MonthlyInOut[] => {
    const allValues = data.flatMap(item => [item.in, item.out]);
    const maxValue = Math.max(...allValues);

    return data.map(item => {
      const inBarHeight = (item.in / maxValue) * MAX_BAR_HEIGHT;
      const outBarHeight = (item.out / maxValue) * MAX_BAR_HEIGHT;

      return {
        ...item,
        inBarHeight,
        outBarHeight,
      };
    });
  };

  if (!monthlyInOutData || monthlyInOutData.length === 0) { return []; }

  const lastFive = monthlyInOutData.slice(-5);
  const lastFour = lastFive.slice(0, -1);

  const formattedData = lastFour.map(item => ({
    ...item,
    monthName: moment(item.month, 'YYYY-MM').format('MMMM'),
    netAmount: Math.round(item.in - item.out),
  }));

  return calculateBarHeights(formattedData.reverse());
};
